// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lq-0";
export var fileList = "_lq-2";
export var removeFileButton = "_lq-1";